import React from 'react'
import { useParams } from 'react-router-dom'
import { OCRTool } from './OCRTool'
import { AudioScribeTool } from './AudioScribeTool'
import { ImageGeneratorTool } from './ImageGeneratorTool'
import { VisualStudioTool } from './VisualStudioTool'
import { QwenVoiceTool } from './QwenVoiceTool'
import { QwenVoiceCloneTool } from './QwenVoiceCloneTool'

export function ToolPlayground() {
  const { toolId } = useParams()

  // Render OCRTool for ocr toolId
  if (toolId === 'ocr') {
    return <OCRTool />
  }

  // Render AudioScribeTool for audio-scribe toolId
  if (toolId === 'audio-scribe') {
    return <AudioScribeTool />
  }

  // Render VisualStudioTool for image-generator or visual-studio toolId
  if (toolId === 'image-generator' || toolId === 'visual-studio') {
    return <VisualStudioTool />
  }

  // Render QwenVoiceTool for qwen-voice toolId
  if (toolId === 'qwen-voice') {
    return <QwenVoiceTool />
  }

  // Render QwenVoiceCloneTool for qwen-voice-clone toolId
  if (toolId === 'qwen-voice-clone') {
    return <QwenVoiceCloneTool />
  }

  // For other tools, show the generic playground (placeholder for now)
  return (
    <div className="h-full flex flex-col animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="text-center py-12">
        <h2 className="text-2xl font-bold text-slate-800 mb-4">Tool: {toolId}</h2>
        <p className="text-slate-600">This tool page is under construction.</p>
        <p className="text-sm text-slate-400 mt-2">Tool ID: {toolId}</p>
      </div>
    </div>
  )
}
